import * as allTypes from '@/store/mutation-type';
import { SELECTION_STATE } from '@/configuration/gabed/patrimoine/patrimoineConf';

export function changesPatrimoineStore(initialStateFunction) {
  return {
    state: initialStateFunction(),
    mutations: {
      [allTypes.RESET_STATE](state) {
        const s = initialStateFunction();
        Object.keys(state).forEach(key => {
          state[key] = s[key];
        });
      },
    },
  };
}

export function getSelectionMessage(state) {
  let message;
  switch (state) {
    case SELECTION_STATE.SELECTED:
      message = 'patrimoine.selectionState.selected';
      break;
    case SELECTION_STATE.SELECTED_PARTIALLY:
      message = 'patrimoine.selectionState.selectedPartially';
      break;
    default:
      message = 'patrimoine.selectionState.unselected';
      break;
  }
  return message;
}

export function getSelectionColor(state) {
  let color;
  switch (state) {
    case SELECTION_STATE.SELECTED:
      color = 'is-success';
      break;
    case SELECTION_STATE.SELECTED_PARTIALLY:
      color = 'is-warning';
      break;
    default:
      color = 'is-primary';
  }
  return color;
}
